export function extractUsPhoneDigits(input) {
  const raw = String(input || '').replace(/\D/g, '');
  if (!raw) return '';
  if (raw.length >= 11 && raw.startsWith('1')) return raw.slice(1, 11);
  return raw.length > 10 ? raw.slice(0, 10) : raw;
}

export function formatUsPhoneInput(input) {
  const d = extractUsPhoneDigits(input);
  if (!d) return '';
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6, 10)}`;
}

export function formatUsPhoneDisplay(input) {
  if (input == null) return '';
  const trimmed = String(input).trim();
  if (!trimmed) return '';
  const d = extractUsPhoneDigits(trimmed);
  if (!d) return trimmed;
  return formatUsPhoneInput(d);
}
